import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function letterValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const password = control.value

    const BigLetter = /[A-Z]/
    const SmallLetter = /[a-z]/

    if (!BigLetter.test(password) || !SmallLetter.test(password)) {
      return {'letterNotValid': true}
    }

    return null;

  }
}
